import commonActions from '@/store/data/common/actions'
import { errorHandler } from '@/utils/helpers'
import { webRequestClient } from '@/services'
import { isEmpty, get } from 'lodash'
import helpers from './helpers'
import { taxonomySegmentsRequestParamsConstructor } from '@/store/data/taxonomies/helpers'

const actions = {
    retrieveItems({ commit, rootGetters }) {
        commit('setIsLoading', true)
        const taxoId = rootGetters['data/customTaxonomies/getWamCustomTaxoId']({ type: 'crm' })
        return webRequestClient
            .get(...taxonomySegmentsRequestParamsConstructor(taxoId))
            .then(crm => {
                if (get(crm, 'status') === 'KO') {
                    errorHandler('Error while retrieving  crm data', commit)
                }
                if (!isEmpty(crm.list)) {
                    commit('setRetrievedItems', {
                        items: helpers.parseData('crm', crm.list)
                    })
                }
            })
            .catch(error => {
                errorHandler(error, commit)
            })
            .finally(() => {
                commit('setIsLoading', false)
            })
    }
}

export default { ...commonActions, ...actions }
